import { Typography } from 'antd'

// Wrapper mỏng cho Typography — giữ API antd để dùng UiTypography.Text/Title/Paragraph
// Tầng 2 theo design system, chỉ forward props, style qua token var(--vbdt-*)
const UiTypography = Typography
export default UiTypography
export const { Text, Title, Paragraph, Link } = Typography
